export default class Transient {
    constructor(elm) {
        //alert('load transient ' + elm.innerHTML);
    }
}